import * as React from 'react';

import { translate } from '~l10n/client';

import { NotFound } from '~teacher/components/NotFound/NotFound';

export function PageNotFound() {
  return (
    <NotFound
      summary={translate('Page Not Found')}
      description={translate(
        "The page doesn't exist, or you don't have permission to view it." /* eslint-disable-line */ /* prettier-ignore */
      )}
    />
  );
}
